const API_ROOTS = {
  development: 'https://v5-dot-ever-forward-club.el.r.appspot.com',
  production: 'https://v4-dot-ever-forward-club.appspot.com',
  millionmask: 'https://million-live-v2-dot-ever-forward-club.el.r.appspot.com',
};

const config = {
  API_ROOT: API_ROOTS.millionmask,
  GOOGLE_ANALYTICS_ID: 'G-3CF2G6LB23',
  FOCUS_TIME: 20, // In seconds
  ERROR_COUNT: 2, // On 2nd error count it will trigger the event
  PARTICIPANTS_COUNT: "85,000",
  COUNTRIES_COUNT: "30",
  WORKSHOPS_COUNT: "1,500"
};

export default config;
